import React, { PropsWithChildren } from "react";
import styles from "./watchlistWell.module.css";

export default function WatchlistWell(props: PropsWithChildren) {
  const { children } = props;

  return <div className={styles.watchlistWell}>{children}</div>;
}
